import {
  RegisterClickRequest,
  RegisterQueryRequest,
} from '@weave/schema-gen-ts/dist/schemas/search/history/v1/search.pb';
import { SchemaSearchHistory } from './service';

export const registerClick = (request: RegisterClickRequest) => SchemaSearchHistory.RegisterClick(request);

export const registerQuery = (request: RegisterQueryRequest) => SchemaSearchHistory.RegisterQuery(request);
